import type { GutXAxisOrgan, OrganLookupCode } from '@repo/types';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
import styles from './GutXAxisOrganList.module.css';
import { GutXAxisOrganBadge } from '#components/GutXAxisOrganBadge';

type OrganRowProps = {
  organ: GutXAxisOrgan;
  /** `kit.age_at_sampling`, in days. */
  age: number;
  pregnant: boolean;
  sex: string;
  /** Every code the map draws, so the badge crops the same gut. */
  drawnCodes?: ReadonlySet<OrganLookupCode>;
  /** Omitted where the list only names the organs, as the PDF report would. */
  onSelect?: () => void;
};

export default function OrganRow({
  organ,
  age,
  pregnant,
  sex,
  drawnCodes,
  onSelect,
}: OrganRowProps) {
  const content = (
    <>
      <GutXAxisOrganBadge
        organ={organ}
        age={age}
        pregnant={pregnant}
        sex={sex}
        drawnCodes={drawnCodes}
      />
      <Typography variant='body-s' className={styles.name}>
        {organ.display_name}
      </Typography>
      {onSelect && (
        <Icon name='chevronForward' size='m' className={styles.chevron} />
      )}
    </>
  );

  return (
    <li className={styles.row}>
      {onSelect ? (
        <button type='button' className={styles.content} onClick={onSelect}>
          {content}
        </button>
      ) : (
        <span className={styles.content}>{content}</span>
      )}
    </li>
  );
}
